import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '~/lib/client'

import { handleApiError } from '~/utils/response'
import { handleResponse } from '~/utils/response'

import { appointmentKeys } from './keys'
import { AppointmentType, GetAppointmentResponse, GetAppointmentsResponse } from '../types'

export const appointmentsQueryOptions = (ops: {
    type?: AppointmentType
}) => {
    return queryOptions({
        queryKey: appointmentKeys.appointments(ops.type),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/appointments?type=${ops.type}`);

                const result = await handleResponse<GetAppointmentsResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
        enabled: !!ops.type
    });
};

export const appointmentQueryOptions = (id: string) => {
    return queryOptions({
        queryKey: appointmentKeys.appointment(id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/appointments/${id}`);

                const result = await handleResponse<GetAppointmentResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                  }
                  return result.data;
            } catch (error) {
                handleApiError(error);
            }
        },
        enabled: !!id
    });
};



